import React from 'react';
import { useSelector } from "react-redux";
import BookingItem from "../BookingItem/BookingItem";
import './bookingList.css';

const BookingList = () => {
    const booking = useSelector(state => state.booking);
    const user_bar = useSelector(state => state.user_bar);

    return (
        <div className="list">
            {
                !booking?.reserves.length
                    ?
                    <div className="empty_list">Нет занятий на указанную дату</div>
                    : false
            }
            {
                !user_bar && booking?.reserves?.map(elem => {
                    return <BookingItem data={ elem } key={ elem.id }/>;
                })
            }
        </div>
    );
};

export default BookingList;